import Rails from "@rails/ujs"
Rails.start()
import $ from "jquery"
import jQuery from "jquery"
window.$ = $
window.jQuery = jQuery
import "./controllers"
import "./notification_button.js"
import "./bulma_collapsible.js"
import "./micromodal.js"
